import { render, staticRenderFns } from "./SupplierFormModal.vue?vue&type=template&id=16953810&scoped=true&"
import script from "./SupplierFormModal.vue?vue&type=script&lang=js&"
export * from "./SupplierFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16953810",
  null
  
)

export default component.exports